import React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { UploadForm } from "../../../../../Site/Questions/PartComponents/UploadForm";
import { AddLogoText, ImageStatus } from "../Resource/Content";

interface IAddLogoProps extends IProcessComponentProps {
    imageBlobData?: { primary: string; secondary: string };
    validationErrors?: string[];
    onChange: (url: { primary: string; secondary: string }) => void;
}

interface IAddLogoState {}

export class AddLogo extends ProcessComponent<IAddLogoProps, IAddLogoState> {
    constructor(props: IAddLogoProps) {
        super(props);
        this.state = {
            imageBlobData: null,
            validationErrors: null,
        };
    }

    isValid() {
        if (!this.props.imageBlobData?.primary) {
            this.props.showErrorMsgPopUp(["Please upload a primary  logo!"]);
            return false;
        }
        return true;
    }

    private renderUploadForm(isPrimary: boolean): JSX.Element {
        const { imageBlobData } = this.props;
        const _imageBlobData = isPrimary ? imageBlobData?.primary : imageBlobData?.secondary;
        const imgStatus = _imageBlobData ? ImageStatus.ImageChosen : ImageStatus.None;

        return (
            <UploadForm
                imageStatus={imgStatus}
                imageBlobData={imageBlobData}
                cssWrapper="mb-50"
                getImageBlobData={(val) => {
                    this.props.onChange({
                        primary: isPrimary ? val : imageBlobData?.primary,
                        secondary: isPrimary ? imageBlobData?.secondary : val,
                    });
                }}
                onSelectAnotherChage={() => {
                    this.props.onChange({
                        primary: isPrimary ? null : imageBlobData?.secondary,
                        secondary: isPrimary ? imageBlobData?.secondary : null,
                    });
                }}
            ></UploadForm>
        );
    }

    private renderMessage() {
        return (
            <>
                <h3>{AddLogoText.LogRecommendations}</h3>
                <p>{AddLogoText.Rules}</p>
                <ul className="list-bulleted">
                    <li>{AddLogoText.Li1}</li>
                    <li>{AddLogoText.Li2}</li>
                    <li>{AddLogoText.Li3}</li>
                    <li>{AddLogoText.Li4}</li>
                </ul>
                <p>{AddLogoText.DoNotWorryMsg}</p>
            </>
        );
    }

    public render(): JSX.Element {
        return (
            <>
                <h3>Add firm logo to the adviser portal</h3>
                <p>
                    <b>Primary logo - </b>This logo will be displayed by default on your platform and any generated
                    documentation. This should be your firms regular logo.
                </p>
                <p>
                    <b>Secondary logo (optional) - </b>This logo will be used for our dark mode feature which is
                    available in platform settings. This should be a version of your firms regular logo which will
                    appear best against a dark background.
                </p>
                <div className="row">
                    <div className="col-6">
                        <p>
                            <b>Primary logo</b>
                        </p>
                        {this.renderUploadForm(true)}
                    </div>
                    <div className="col-6">
                        <p>
                            <b>Secondary logo (optional)</b>
                        </p>
                        {this.renderUploadForm(false)}
                    </div>
                </div>
                {this.renderMessage()}
            </>
        );
    }
}
